import React, { useEffect, useRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string | null;
  unit?: string | null;
}
function CustomInput({ label, unit, defaultValue, ...props }: InputProps) {
  const refRc = useRef(null);
  const [value, setValue] = React.useState(defaultValue);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 10,
        marginBottom: 10,
        fontSize: 12,
      }}
    >
      <label>{label}</label>
      <div
        style={{
          borderRadius: 8,
          borderColor: '#f0f0f0',
          boxShadow: 'none',
          border: '1px solid #f0f0f0',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          {...props}
          style={{
            padding: 10,
            borderRadius: 8,
            borderColor: '#f0f0f0',
            boxShadow: 'none',
            border: 'none',
            flex: 1,
          }}
        />
        {unit && (
          <span
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 5,
              color: '#3c3c3c50',
            }}
          >
            {unit}
          </span>
        )}
      </div>
    </div>
  );
}

export default CustomInput;
